/**
 * React Query keys for the organization-service identity reads.
 */
export const identitiesKeys = {
  /** Everyone with access to one office's location, keyed by the office id. */
  locationIdentities: (officeId) => ['identities', 'location', officeId],
};
